export const algoliaClickHit = ({ index, queryID, hit, collection, position }) => {
    const hitWithCollection = hit;
    hitWithCollection.collection_name = collection;
    window.dataLayer.push({
        event: 'alg_click_hit',
        algolia_click: {
            index,
            queryID,
            objectIDs: [hit.objectID],
            positions: [position],
            hit: hitWithCollection
        }
    });
    window.Cookies.set('alg_last_queryID', queryID, { expires: 1, sameSite: 'lax' });
    window.Cookies.set('alg_last_index', index, { expires: 1, sameSite: 'lax' });
};
